import(/* webpackMode: "eager", webpackExports: ["TermConditionPage"] */ "/www/wwwroot/gass/fe-prod/components/legal/term-condition-page.tsx");
